import { DI,DIEx } from 'gl-commonui'
const { injectable, inject } = DI
const { lazyInject } = DIEx
export {
    injectable,
    inject,
    lazyInject
}